module.exports = __webpack_public_path__ + "media/img/Scholarships2u-for-Institutions-Logo-bb39126c0ca3a55e87073be96659e8ae.png";